export const ENV_PRODUCTION = 'production';
export const ENV_STAGING = 'staging';
export const ENV_API_PROD = 'Prod';
export const ENV_API_PREPROD = 'PreProd';

export const ACTION_GET_GLOBAL_SEARCH_AUTOCOMPLETE_DATA = 'get_global_search_autocomplete_data';
export const ACTION_GET_BOOKING_API_TOKEN = 'get_booking_api_token';
export const ACTION_GET_GLOBAL_OFFERS = 'get_global_offers';
export const ACTION_GET_GLOBAL_GROUP_OFFERS = 'get_global_group_offers';
export const ACTION_GET_GLOBAL_VENUES = 'get_global_venues';
export const ACTION_GET_GLOBAL_VENUE_LOCATIONS = 'get_global_venue_locations';
export const ACTION_GET_GLOBAL_GIFT_SHOP_HOTELS = 'get_global_gift_shop_hotels';
export const ACTION_GET_GLOBAL_GIFTS = 'get_global_gifts';
export const ACTION_GET_HOTEL_OFFERS = 'get_hotel_offers';
export const ACTION_GET_HOTEL_VENUES = 'get_hotel_venues';
export const ACTION_GET_HOTEL_THINGS_TO_DO = 'get_hotel_things_to_do';
export const ACTION_GET_HOTEL_THINGS_TO_DO_OFFERS = 'get_hotel_thing_to_do_related_offers';
export const ACTION_GET_HOTEL_GIFTS = 'get_hotel_gifts';
export const ACTION_GET_HOTEL_REVIEWS = 'get_hotel_reviews';

export const COOKIE_KEY_API_TOKEN = 'rydges_ba_token';

export const COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY = window.Rydges['sharedConstants']['COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY'];

export const COOKIE_KEY_ACCOMMODATION_SEARCH_LOCATION = window.Rydges['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_LOCATION'];
export const COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE = window.Rydges['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE'];
export const COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE = window.Rydges['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE'];
export const COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_SEARCHES = window.Rydges['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_SEARCHES'];
export const COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_VIEWED = window.Rydges['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_VIEWED'];

export const COOKIE_KEY_GLOBAL_SEARCH_RECENT = window.Rydges['sharedConstants']['COOKIE_KEY_GLOBAL_SEARCH_RECENT'];

export const COOKIE_KEY_OFFERS_SEARCH_LOCATION = window.Rydges['sharedConstants']['COOKIE_KEY_OFFERS_SEARCH_LOCATION'];
export const COOKIE_KEY_OFFERS_SEARCH_TYPE = window.Rydges['sharedConstants']['COOKIE_KEY_OFFERS_SEARCH_TYPE'];

export const COOKIE_KEY_VENUES_SEARCH_LOCATION = window.Rydges['sharedConstants']['COOKIE_KEY_VENUES_SEARCH_LOCATION'];
export const COOKIE_KEY_VENUES_SEARCH_OCCASION = window.Rydges['sharedConstants']['COOKIE_KEY_VENUES_SEARCH_OCCASION'];
export const COOKIE_KEY_VENUES_SEARCH_GUESTS = window.Rydges['sharedConstants']['COOKIE_KEY_VENUES_SEARCH_GUESTS'];

export const EVT_STAYS_MEMBERSHIP_REST__GIFTCARDS_BASE_EVT_STAYS = window.Rydges['sharedConstants']['EVT_STAYS_MEMBERSHIP_REST__GIFTCARDS_BASE_EVT_STAYS'];

export const EVENT_VIRTUAL_PAGEVIEW = window.Rydges['sharedConstants']['EVENT_VIRTUAL_PAGEVIEW'];

export const EVENT_HOTEL_ROOM_MODAL_LOADED = 'hotel_room_modal_loaded.rydges';
export const EVENT_INPUTS_CHANGED_SEARCH = 'search_inputs_changed.rydges';
export const EVENT_SELECT_FILTER_CHANGED = 'select_filter_changed.rydges';
export const EVENT_SUBMIT_CLICKED_SEARCH = 'search_submit_clicked.rydges';
export const EVENT_FACILITES_FILTER_CHANGED_SEARCH = 'search_facilities_filter_changed.rydges';
export const EVENT_VIEW_TYPE_CHANGED = 'search_view_type_changed.rydges';

export const EVENT_BALANCE_ELEMENTS = 'balance_elements.rydges';
export const EVENT_BOOKING_SEARCH_PLACE_CHANGED = 'event_booking_search_place_changed';
export const EVENT_BOOKING_FORM_LOADED = 'booking_form_loaded';

export const EVENT_GIFTS_OCCASION_FILTER_CHANGED = 'gifts_occasion_filter_changed.rydges';
export const EVENT_GIFTS_RECIPIENT_FILTER_CHANGED = 'gifts_recipient_filter_changed.rydges';
export const EVENT_GIFTS_LOCATION_FILTER_CHANGED = 'gifts_location_filter_changed.rydges';
export const EVENT_GIFTS_BRAND_FILTER_CHANGED = 'gifts_brand_filter_changed.rydges';
export const EVENT_GIFTS_VOUCHER_TYPE_FILTER_CHANGED = 'gifts_voucher_type_filter_changed.rydges';
export const EVENT_GIFTS_DELIVERY_METHOD_FILTER_CHANGED = 'gifts_delivery_method_filter_changed.rydges';
export const EVENT_GIFTS_SORT_CHANGED = 'gifts_sort_changed.rydges';
export const EVENT_GIFTS_SEARCH_FILTER_CHANGED = 'gifts_search_filter_changed.rydges';

export const DATE_FORMAT_IN_VIEW = 'DD MMM, YYYY';
export const DATE_FORMAT_AUS = 'DD/MM/YYYY';
export const DATE_FORMAT_ISO = 'MM/DD/YYYY';
export const OUTAGE_DATE_FORMAT_ISO = 'MM-DD-YYYY';
export const DATE_FORMAT_SITEMINDER = 'YYYY-MM-DD';



// WEBPACK FOOTER //
// ./scripts/util/constants.js